import React from 'react';
import {useTranslation} from "react-i18next";
import {LoadingScreen} from "@dreebit-registry/vsm-microservice-components";
import "../i18n/config";

interface Props {
    children?: React.ReactNode
}

const TranslationProvider = ({children}: Props) => {
    const {i18n} = useTranslation();

    if (!i18n) {
        return <LoadingScreen />
    }

    return <>
        {children}
    </>
}

export default TranslationProvider;
